module.exports = __webpack_public_path__ + "static/img/Stars.7d13d8cc.png";